import "../global.d.js";
import { validateTidalLicense } from "@workwave-tidal/license-utils";
export * from "./muiBase.js";
export * from "./getShouldForwardProp.js";
export * from "./isDev.js";
export * from "./printTidalVersions.js";
export * from "./registerTidalVersion.js";
import { validateTidalLicense as validateTidalLicense2 } from "@workwave-tidal/license-utils";
validateTidalLicense();
export {
  validateTidalLicense2 as validateTidalLicense
};
//# sourceMappingURL=index.js.map
